<template>
    <div class="flex align-bottom mt-1 gap-1 group">
        <div class="text-center" v-for="number in max" :key="number">
            <div
                class="relative p-0.5 rounded-full flex items-center justify-center cursor-pointer focus:outline-none ring-indigo-500"
            >
                <div
                    aria-hidden="true"
                    class="border border-black border-opacity-10 rounded-full flex items-center justify-center tabular-nums text-xs"
                    :class="{
                        'bg-gray-200': number !== value,
                        'bg-red-400 text-red-800': number === 1 && number === value,
                        'bg-orange-400 text-orange-800': number === 2 && number === value,
                        'bg-yellow-400 text-yellow-800': number === 3 && number === value,
                        'bg-blue-400 text-blue-800': number === 4 && number === value,
                        'bg-green-400 text-green-800': number === 5 && number === value,
                        'h-4 w-4': size === 'sm',
                        'h-6 w-6': size === 'md',
                    }"
                >
                    <span class="invisible group-hover:visible">{{ number }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormQuestionLevelDifficultyInput ',
    props: {
        max: {
            required: false,
            type: Number,
            default: 5,
        },
        size: {
            required: false,
            type: String,
            default: 'sm',
            validator(value) {
                return ['base', 'sm'].includes(value);
            },
        },
        value: {
            required: true,
        },
    },
};
</script>
